export default {"src":"/_next/static/image/src/onboarding/AccountFeatures/change-recipes.5bf6de7ad98adb8cb56f51372fee7fcc.svg","height":71,"width":70};